import { CurrentRfqStatusThemeSizeConfig } from './types';

const medium: CurrentRfqStatusThemeSizeConfig = {
  currentRfqStatus: {},
};

export default medium;
